import Sidebar from "../components/Sidebar";
import AdminDash from "./AdminDash";
import UserDash from "./UserDash";
import { auth, db } from "../firebaseConfig";
import { Link } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { updatePassword, onAuthStateChanged} from "firebase/auth";
import { useEffect, useState } from "react";
import { ThreeDots } from 'react-loader-spinner';
import TextField from "@mui/material/TextField";
import Swal from "sweetalert2";

function Dashboard() {
    const [user, setUser] = useState(null);
    const [userRole, setUserRole] = useState(null);
    const [mustResetPassword, setMustResetPassword] = useState(false);
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(true);

    const handlePassChange = async (e) => {
        e.preventDefault();

        if (newPassword !== confirmPassword) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Passwords do not match.",
                confirmButtonColor: "#3085d6",
            });
            return;
        }

        try {
            const currentUser = auth.currentUser;
            await updatePassword(currentUser, newPassword);
            const userRef = doc(db, "users", currentUser.uid);
            await updateDoc(userRef, { mustResetPassword: false });

            Swal.fire({
                icon: "success",
                title: "Password Updated!",
                text: "Your password has been successfully updated.",
                confirmButtonColor: "#3085d6",
            });
            setMustResetPassword(false);
            setNewPassword("");
            setConfirmPassword("");
        } 
        
        catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Make sure your new password meets the requirements.",
                confirmButtonColor: "#3085d6",
            });
        }
    };

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
        setUser(currentUser);

        if (!currentUser) {
            setLoading(false);
            return;
        }

        try {
            const userRef = doc(db, "users", currentUser.uid);
            const userSnap = await getDoc(userRef);

            if (userSnap.exists()) {
                const data = userSnap.data();
                setUserRole(data.role || "user");
                setMustResetPassword(data.mustResetPassword || false);
            } 
        } 
        
        catch (error) {
            console.error("Error fetching user role:", error);
            setUserRole("user");
            setMustResetPassword(false);
        } 
        
        finally {
            setLoading(false);
        }
        });

        return () => unsubscribe();
    }, []);

    if (!user && !loading) {
        return (
        <div className="please-login" style={{backgroundColor: "white", color: "black"}}>
            <p id="please-login-text" style={{marginTop: "-5px"}}>Please log in</p>
            <Link className="link-btn" to="/"><button className="please-login-button">Log in</button></Link>
        </div>
        );
    }

    if (loading) {
        return (
        <div className="dashboard" style={{margin: "0",position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
            background: "transparent", boxShadow: "none", display: "flex", alignItems: "center", justifyContent: "center", width: "100vw",
            height: "100vh", zIndex: 9999}}>
            <ThreeDots color="#00BFFF" height={80} width={80}/>
        </div>
        );
    }

    if (mustResetPassword) {
        return (
        <div className="password-popup">
            <div className="reset-pass-div">
                <h2 id="change-pass-text">Please Reset Password</h2>
                <form className="change-pass-form" onSubmit={handlePassChange} name="change-password-form">
                    <TextField label="New Password" type="password" placeholder="" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required size="medium" sx={{
                                "& .MuiInputLabel-root.Mui-focused": { color: "black" }, "& .MuiOutlinedInput-root": { "&.Mui-focused fieldset": { border: "1px solid black", 
                                    color: "black" }, }, }}/>

                    <TextField label="Confirm Password" type="password" placeholder="" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required 
                        size="medium" sx={{ "& .MuiInputLabel-root.Mui-focused": { color: "black" }, "& .MuiOutlinedInput-root": { "&.Mui-focused fieldset": { border: "1px solid black", 
                            color: "black"},},}}/>
                    <button type="submit" className="auth-btn">Change Password</button>
                </form>
                <p style={{ fontSize: "10px", textAlign: "left", marginLeft: "50px"}}>Your new password <strong><u>must</u></strong> be:</p>
                <ul>
                    <li>Be more than 6 characters long</li>
                    <li>Include at least one <u style={{ fontWeight: "bold" }}>Uppercase character</u></li>
                    <li>Include at least one <u style={{ fontWeight: "bold" }}>Lowercase character</u></li>
                    <li>Include at least one <u style={{ fontWeight: "bold" }}>Special character</u></li>
                </ul>
                <p style={{ fontSize: "10px", textAlign: "left", marginLeft: "50px", color: "red"}}>Refrain from using easily guessable passwords</p>
                <p style={{ fontSize: "10px", marginTop: "-8px", textAlign: "left", marginLeft: "50px", color: "red"}}>Do not use previously used passwords</p>
            </div>
        </div>
        );
    }

    if (userRole === "admin") {
        return (
        <div className="main-page">
            <Sidebar />
            <AdminDash/>
        </div>
        );
    }

    return (
        <div className="main-page">
            <Sidebar />
            <UserDash/>
        </div>
    );
}

export default Dashboard;
